import { render, staticRenderFns } from "./SendEmailPopup.vue?vue&type=template&id=6e42f68b&scoped=true&"
import script from "./SendEmailPopup.vue?vue&type=script&lang=js&"
export * from "./SendEmailPopup.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailPopup.vue?vue&type=style&index=0&id=6e42f68b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42f68b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e42f68b')) {
      api.createRecord('6e42f68b', component.options)
    } else {
      api.reload('6e42f68b', component.options)
    }
    module.hot.accept("./SendEmailPopup.vue?vue&type=template&id=6e42f68b&scoped=true&", function () {
      api.rerender('6e42f68b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/SendEmailPopup.vue"
export default component.exports